"use client"

import { motion } from "framer-motion"
import Image from "next/image"
import { Card, CardContent } from "@/components/ui/card"

const galleryImages = [
  "https://cdn.nicktronicit.dev/gtc/gallery3.png",
  "https://cdn.nicktronicit.dev/gtc/gallery4.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery5.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery6.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery7.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery8.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery9.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery10.png",
  "https://cdn.nicktronicit.dev/gtc/gallery11.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery12.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery13.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery14.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery15.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery16.png",
  "https://cdn.nicktronicit.dev/gtc/gallery17.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery18.png",
  "https://cdn.nicktronicit.dev/gtc/gallery19.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery20.png",
  "https://cdn.nicktronicit.dev/gtc/gallery21.jpg",
  "https://cdn.nicktronicit.dev/gtc/gallery22.png",
  "https://cdn.nicktronicit.dev/gtc/gallery24.jpg",
]

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
}

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
}

const imageVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.4 },
  },
}

export default function GalleryPage() {
  return (
    <div className="min-h-screen py-8 sm:py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-8 sm:mb-10 md:mb-12 lg:mb-16"
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 text-balance text-foreground font-[family-name:var(--font-display)]">
              Gallery
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-muted-foreground text-pretty max-w-2xl mx-auto">
              Take a look at our delicious soul food dishes and catering events
            </p>
          </motion.div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6 lg:gap-8"
          >
            {galleryImages.map((src, index) => (
              <motion.div key={index} variants={imageVariants}>
                <Card className="overflow-hidden group">
                  <CardContent className="p-0">
                    <div className="relative aspect-square">
                      <Image
                        src={src || "/placeholder.svg"}
                        loading="eager"
                        alt={`Good Thangz Cookin gallery image ${index + 1}`}
                        fill
                        className="object-cover group-hover:scale-105 transition-transform duration-300"
                        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, (max-width: 1280px) 33vw, 25vw"
                      />
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  )
}
